<template>
    <div id="campanha-cadastro">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <h4 class="header">{{ campanha.campanha_nome }} - Listagem de clientes</h4>

                            <button
                                class="btn waves-effect waves-light right"
                                @click="downloadCSV()"
                            >
                                <i class="material-icons left">file_download</i>
                                Exportar
                            </button>

                            <table class="responsive-table bordered striped lista-clientes">
                                <thead>
                                    <tr>
                                        <th style="width: 30%">Nome completo</th>
                                        <th style="width: 10%">Profissão</th>
                                        <th style="width: 20%">Endereço</th>
                                        <th style="width: 15%">Celular</th>
                                        <th style="width: 15%">Telefone</th>
                                        <th style="width: 5%">Email</th>
                                        <th style="width: 5%">Gênero</th>
                                        <th style="width: 10%">Estado Civil</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in clientes">
                                    <td style="width: 30%">
                                        <input type="checkbox" v-model="array" :value="item.cliente_id" :id="item.cliente_id" />
                                        <label :for="item.cliente_id">{{ item.pessoa_nome }}</label>
                                    </td>
                                    <td style="width: 10%">{{ item.pessoa_profissao }}</td>
                                    <td style="width: 20%">{{ item.endereco_logradouro }}</td>
                                    <td style="width: 10%">{{ item.pessoa_celular | phone }}</td>
                                    <td style="width: 10%">{{ item.pessoa_telefone | phone }}</td>
                                    <td style="width: 10%">{{ item.pessoa_email }}</td>
                                    <td style="width: 10%">{{ item.pessoa_sexo | genero }}</td>
                                    <td style="width: 10%">{{ item.pessoa_estado_civil | estadoCivil }}</td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>
<style>
    table.lista-clientes td {
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
</style>
<script>
    import { get, put } from '@/helpers/api';
    import Message from '@/helpers/message';

    export default {
        components: {
        },
        data: () => ({
            campanha: {
                campanha_nome: '',
                campanha_id: '',
            },
            array: [],
            clientes: [],
        }),
        created() {
            let self = this;
            get('campanha/'+this.$route.params.id).then(function (response) {
                self.campanha = response.data.result.data;
            });

            get('cliente/listagem-campanha').then(function (response) {
                self.clientes = response.data.result.data;
            });
        },
        methods: {
            save() {

            },
            downloadCSV(args) {
                let self = this;
                let data, filename, link;
                let dataExport = [];

                this.array.forEach((id) => {
                    this.clientes.forEach((cliente) => {
                        if (id === cliente.cliente_id) {
                            dataExport.push({
                                nome: cliente.pessoa_nome,
                                profissao: cliente.pessoa_profissao,
                                endereco: cliente.endereco_logradouro,
                                celular: cliente.pessoa_celular,
                                telefone: cliente.pessoa_telefone,
                                email: cliente.pessoa_email,
                                genero: cliente.pessoa_sexo,
                                estadoCivil: cliente.pessoa_estado_civil,
                            });
                        }
                    });
                });

                let csv = this.convertArrayOfObjectsToCSV({
                    data: dataExport
                });
                if (csv == null) return;

                filename = 'export.csv';

                if (!csv.match(/^data:text\/csv/i)) {
                    csv = 'data:text/csv;charset=utf-8,' + csv;
                }
                data = encodeURI(csv);

                link = document.createElement('a');
                link.setAttribute('href', data);
                link.setAttribute('download', filename);
                link.click();
            },
            convertArrayOfObjectsToCSV(args) {
                let result, ctr, keys, columnDelimiter, lineDelimiter, data;

                data = args.data || null;
                if (data == null || !data.length) {
                    return null;
                }

                columnDelimiter = args.columnDelimiter || ',';
                lineDelimiter = args.lineDelimiter || '\n';

                keys = Object.keys(data[0]);

                result = '';
                result += keys.join(columnDelimiter);
                result += lineDelimiter;

                data.forEach(function(item) {
                    ctr = 0;
                    keys.forEach(function(key) {
                        if (ctr > 0) result += columnDelimiter;

                        result += item[key];
                        ctr++;
                    });
                    result += lineDelimiter;
                });

                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/campanha/Clientes.vue